import type { ReactNode } from 'react'

/**
 * Suggested-resources rows (spec §8.5) — SHARED between A6's Deep Dives
 * missed-gap block (`deep-dives.tsx`) and A7's behavioral Result-gap
 * callout. Deliberately pure/presentational: every row (including its
 * `assigned` flag and toggle handler) is fully caller-supplied, so this
 * component carries no store dependency and no SD-specific coupling — a
 * caller just needs to build `SuggestedResourceRow[]` however it derives
 * assign state (A6 uses the slice's `attachments`/`toggleAttachment`, keyed
 * `resource:{submissionId}:{resourceId}`; A7 is free to do the same or
 * something else entirely).
 */

export type SuggestedResourceType = 'Read' | 'Drill' | 'Video'

export interface SuggestedResourceRow {
  id: string
  type: SuggestedResourceType
  label: string
  meta: string
  assigned: boolean
  onToggleAssign: () => void
}

export function SuggestedResources(props: {
  rows: SuggestedResourceRow[]
}): ReactNode {
  const { rows } = props

  return (
    <div className="flex flex-col gap-1.5">
      {rows.map((row) => (
        <div
          key={row.id}
          className="flex items-center gap-2.5 rounded-lg border border-(--cd-border-2) bg-(--cd-inset) px-2.5 py-1.5"
        >
          <span className="shrink-0 rounded-full border border-(--cd-border-2) bg-(--cd-bg) px-2 py-0.5 text-[10.5px] font-bold text-(--cd-text-muted)">
            {row.type}
          </span>
          <span className="flex-1 text-[12.5px] text-(--cd-text-2)">
            {row.label}
          </span>
          <span className="shrink-0 text-[11px] text-(--cd-text-faint)">
            {row.meta}
          </span>
          <button
            type="button"
            onClick={row.onToggleAssign}
            className="shrink-0 rounded-full border px-2.5 py-1 text-[11px] font-semibold"
            style={
              row.assigned
                ? {
                    background:
                      'color-mix(in oklab, var(--cd-green) 12%, transparent)',
                    color: 'var(--cd-green)',
                    borderColor:
                      'color-mix(in oklab, var(--cd-green) 35%, transparent)',
                  }
                : {
                    background: 'transparent',
                    color: 'var(--cd-text-muted)',
                    borderColor: 'var(--cd-border-2)',
                  }
            }
          >
            {row.assigned ? '✓ Assigned' : '+ Assign'}
          </button>
        </div>
      ))}
    </div>
  )
}
